var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchShipment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0206 10.0782L13.876 12.9328L12.9326 13.8762L10.078 11.0208C9.01581 11.8723 7.69465 12.3354 6.33331 12.3335C3.02131 12.3335 0.333313 9.6455 0.333313 6.3335C0.333313 3.0215 3.02131 0.333496 6.33331 0.333496C9.64531 0.333496 12.3333 3.0215 12.3333 6.3335C12.3352 7.69483 11.8721 9.01599 11.0206 10.0782ZM9.68331 9.5835C10.5294 8.71342 11.0019 7.54712 11 6.3335C11 3.75483 8.91131 1.66683 6.33331 1.66683C3.75465 1.66683 1.66665 3.75483 1.66665 6.3335C1.66665 8.9115 3.75465 11.0002 6.33331 11.0002C7.54693 11.0021 8.71324 10.5296 9.58331 9.6835L9.68331 9.5835Z",
    fill: "#545859"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchShipment);
export default __webpack_public_path__ + "static/media/search-shipment.5d57b87b.svg";
export { ForwardRef as ReactComponent };